export { ReactComponent as IconExperience } from "./media/icons/experience.svg";
export { ReactComponent as IconIndustry } from "./media/icons/industry.svg";
export { ReactComponent as IconBridge } from "./media/icons/bridge1.svg";
export { ReactComponent as IconRelationship } from "./media/icons/relationship.svg";
export { ReactComponent as IconAnalysis } from "./media/icons/services/developers/market-supply-demand-analysis.svg";
export { ReactComponent as IconOngoing } from "./media/icons/services/developers/ongoing.svg";
export { ReactComponent as IconIdentification } from "./media/icons/services/developers/supplier-identification.svg";
export { ReactComponent as IconOptimisation } from "./media/icons/services/developers/supply-chain-optimisation.svg";
export { ReactComponent as IconBidding } from "./media/icons/services/suppliers/bidding-management.svg";
export { ReactComponent as IconPartnerships } from "./media/icons/services/suppliers/business-partnerships.svg";
export { ReactComponent as IconCampaigns } from "./media/icons/services/suppliers/marketing-campaigns.svg";
export { ReactComponent as IconEntry } from "./media/icons/services/suppliers/market-entry-strategy.svg";
export { ReactComponent as IconExecution } from "./media/icons/services/suppliers/project-execution-support.svg";
export { ReactComponent as IconOpportunities } from "./media/icons/services/suppliers/project-opportunities.svg";
export { ReactComponent as IconRisk } from "./media/icons/services/suppliers/project-risk-assessment.svg";
export { ReactComponent as IconStakeholder } from "./media/icons/services/suppliers/stakeholder-engagement.svg";
export { ReactComponent as IconVerification } from "./media/icons/services/investors/independent-verification.svg";
export { ReactComponent as IconMarketEntry } from "./media/icons/services/investors/market-entry-support.svg";
export { ReactComponent as IconInsights } from "./media/icons/services/investors/market-insigts-and-intelligence.svg";
export { ReactComponent as IconProjectDue } from "./media/icons/services/investors/project-due-diligence.svg";
export { ReactComponent as IconMonitoring } from "./media/icons/services/investors/project-monitoring.svg";
export { ReactComponent as IconRiskAssessment } from "./media/icons/services/investors/risk-assessment.svg";
export { ReactComponent as IconTechDue } from "./media/icons/services/investors/technical-due-diligence.svg";
export { ReactComponent as IconClaim } from "./media/icons/services/insurers/claim-management-support.svg";
export { ReactComponent as IconLossControl } from "./media/icons/services/insurers/loss-control-and-risk-mitigation.svg";
export { ReactComponent as IconRiskAssessmentSupport } from "./media/icons/services/insurers/risk-assessment-and-underwriting-support.svg";
export { ReactComponent as IconCertificate } from "./media/icons/certificate.svg";
export { ReactComponent as IconIntegrity } from "./media/icons/integrity.svg";
export { ReactComponent as IconCollaboration } from "./media/icons/relationship.svg";
export { ReactComponent as IconRight } from "./media/icons/right.svg";
export { ReactComponent as IconMenu } from "./media/icons/menu.svg";
export { ReactComponent as IconClose } from "./media/icons/close.svg";

export const weBridgeLogo = {
  white: require("./media/logo/WeBridge-logo-white.png"),
  red: require("./media/logo/WeBridge-logo-red.png"),
};
export const gwsceLogo = require("./media/logo/GWSCE-logo.png");
export const gwscePattern = require("./media/background/gwsce-pattern.jpeg");
// export const windmillPhotosArray = loadWindmillPhotos();
export const windmillPhotosArray = [
  require("./media/windmill/photos/WTG9.jpg"),
  require("./media/windmill/photos/WTG8.jpg"),
  require("./media/windmill/photos/WTG7.jpg"),
  require("./media/windmill/photos/WTG1.jpg"),
  require("./media/windmill/photos/WTG2.jpg"), //
  require("./media/windmill/photos/WTG3.jpg"),
  require("./media/windmill/photos/WTG4.jpg"),
  require("./media/windmill/photos/WTG5.jpg"),
  require("./media/windmill/photos/WTG6.jpg"),
  require("./media/windmill/photos/WTG10.jpg"), //
  require("./media/windmill/photos/WTG11.jpg"),
  require("./media/windmill/photos/WTG12.jpg"),
  require("./media/windmill/photos/WTG13.jpg"),
  require("./media/windmill/photos/WTG14.jpg"),
  require("./media/windmill/photos/WTG15.jpg"), //
];

export const constructionPhotosArray = [
  require("./media/windmill/photos/construction1.jpg"),
  require("./media/windmill/photos/construction2.jpg"),
  require("./media/windmill/photos/construction3.jpg"),
  require("./media/windmill/photos/construction4.jpg"),
  require("./media/windmill/photos/construction5.jpg"),
  require("./media/windmill/photos/construction6.jpg"),
  require("./media/windmill/photos/construction7.jpg"),
  require("./media/windmill/photos/construction8.jpg"),
  require("./media/windmill/photos/construction9.jpg"),
];

export const forDevelopersImg = require("./media/windmill/photos/WTG-d1.png");
export const forSuppliersImg = require("./media/windmill/photos/suppliers.png");

export const homeBackground = require("./media/background/wind-turbine.jpg");
export const gwsceBackground = require("./media/background/gwsce-bg.jpeg");
export const windmillVideosArray = [
  require("./media/windmill/videos/WTG1.mp4"),
  require("./media/windmill/videos/WTG2.mp4"),
  require("./media/windmill/videos/platform.mp4"),
  require("./media/windmill/videos/WTG4.mp4"),
  require("./media/windmill/videos/WTG5.mp4"),
  require("./media/windmill/videos/sailing.mp4"),
];

export const londonPhotosArray = [
  require("./media/london/london1.jpg"),
  require("./media/london/phone-booth.jpg"),
];

export const backgroundArtArray = {
  windmillArt: require("./media/background/windmill-art.png"),
  windmillWaterArt: require("./media/background/windmill-water-art.png"),
  logoArt: require("./media/background/logoArt.png"),
  insights: require("./media/background/insights.jpg"),
  weekly: require("./media/background/weekly-background.jpg"),
  events: require("./media/background/events-background.jpeg"),
  investors: require("./media/background/investors.jpg"),
  insurers: require("./media/background/insurers.jpg"),
};

export const iconArray = {
  linkedin: require("./media/icons/webridge-linkedin.png"),
  wechat: require("./media/icons/webridge-wechat.png"),
};

export const other = {
  wechatQR: require("./media/other/wechat-qr.jpg"),
};

export const insight1Media = [
  require("./media/forInsights/insight1/1.png"),
  require("./media/forInsights/insight1/2.png"),
  require("./media/forInsights/insight1/3.png"),
  require("./media/forInsights/insight1/4.png"),
  require("./media/forInsights/insight1/5.png"),
];

export const insight2Media = [
  require("./media/forInsights/insight2/WTG.png"),
  require("./media/forInsights/insight2/goldwind.png"),
  require("./media/forInsights/insight2/mingyang.png"),
  require("./media/forInsights/insight2/cssc.jpg"),
];

export const insight3Media = [
  require("./media/forInsights/insight3/1.png"),
  require("./media/forInsights/insight3/2.png"),
];

export const insight4Media = [
  require("./media/forInsights/insight4/map.png"),
  require("./media/forInsights/insight4/graph.png"),
];
export const insight5Media = [
  require("./media/forInsights/insight5/offshore wind farm construction-1.jpg"),
  require("./media/forInsights/insight5/offshore wind farm construction-2.jpg"),
  require("./media/forInsights/insight5/offshore wind jacket.jpg"),
  require("./media/forInsights/insight5/offshore wind farm construction-3.jpg"),
];

export const insight6Media = [
  require("./media/forInsights/insight6/offshore wind farm.jpg"),
];
export const insight7Media = [require("./media/forInsights/insight7/tax.jpg")];
export const insight8Media = [
  require("./media/forInsights/insight8/windmill.jpg"),
];
export const insight9Media = [require("./media/forInsights/insight9/logo.png")];
export const insight10Media = [
  require("./media/forInsights/insight10/sany exhibition.jpg"),
  require("./media/forInsights/insight10/cssc exhibition.jpg"),
  require("./media/forInsights/insight10/windmill construction.jpg"),
  require("./media/forInsights/insight10/Aaron and Boskalis.jpg"),
];

export const insight11Media = [
  require("./media/forInsights/insight11/CFD_Nov23.jpg"),
  require("./media/forInsights/insight11/offshore wind.jpg"),
  require("./media/forInsights/insight11/WeBridge Quote - AR6.png"),
];
export const insight12Media = [
  require("./media/forInsights/insight12/cop28-1.jpeg"),
  require("./media/forInsights/insight12/cop28-2.jpeg"),
  require("./media/forInsights/insight12/cop28-3.jpeg"),
  require("./media/forInsights/insight12/cop28-4.jpeg"),
  require("./media/forInsights/insight12/cop28-5.jpeg"),
  require("./media/forInsights/insight12/cop28-6.jpeg"),
  require("./media/forInsights/insight12/cop28-7.jpeg"),
  require("./media/forInsights/insight12/cop28-8.jpeg"),
];

export const insight13Media = [
  require("./media/forInsights/insight13/offshore wind developers.jpeg"),
];
export const insight14Media = [
  require("./media/forInsights/insight14/document.jpeg"),
  require("./media/forInsights/insight14/table1.jpeg"),
  require("./media/forInsights/insight14/table2.jpeg"),
  require("./media/forInsights/insight14/table3.jpeg"),
  require("./media/forInsights/insight14/table4.jpeg"),
];

export const insight15Media = [
  require("./media/forInsights/insight15/regulation.jpeg"),
];
export const insight16Media = [
  require("./media/forInsights/insight16/FOWT-2024-Conference-Marseille.jpg"),
];
export const insight17Media = [
  require("./media/forInsights/insight17/Global-Offshore-Wind-event-floor.jpg"),
  require("./media/forInsights/insight17/Global-Offshore-Wind-event-poster.jpg"),
];
export const insight18Media = [
  require("./media/forInsights/insight18/Offshore-Wind-Farm.jpeg"),
];
export const insight19Media = [
  require("./media/forInsights/insight19/at_WindEnergy_Hamburg.jpeg"),
];
export const insight20Media = [
  require("./media/forInsights/insight20/at_floating_offshore_wind.jpeg"),
];
export const insight21Media = [
  require("./media/forInsights/insight21/uk-china-offshore-wind-partnership-reception.jpg"),
  require("./media/forInsights/insight21/speech.jpg"),
  require("./media/forInsights/insight21/speech2.jpg"),
  require("./media/forInsights/insight21/Aaron-communicating.jpg"),
  require("./media/forInsights/insight21/event-group-photo.jpg"),
];
export const insight22Media = [
  require("./media/forInsights/insight22/Adu-Dhabi-exhibition-conference.jpg"),
];
export const insight23Media = [
  require("./media/forInsights/insight23/trump.jpeg"),
  require("./media/forInsights/insight23/sailing-on-sea.jpeg"),
  require("./media/forInsights/insight23/offshore-wind-farm.jpeg"),
];
export const insight24Media = [
  require("./media/forInsights/insight24/shipment.jpeg"),
  require("./media/forInsights/insight24/offshore-wind-shipping.jpeg"),
  require("./media/forInsights/insight24/shipment2.jpeg"),
];
export const insight25Media = [
  require("./media/forInsights/insight25/offshore-windfarm-manufacturing1.jpg"),
  require("./media/forInsights/insight25/offshore-windfarm-manufacturing2.jpg"),
  require("./media/forInsights/insight25/offshore-windfarm-manufacturing3.jpg"),
  require("./media/forInsights/insight25/offshore-windfarm-manufacturing4.jpg"),
];
export const insight26Media = [
  require("./media/forInsights/insight26/wind-turbine.jpg"),
];
export const insight27Media = [
  require("./media/forInsights/insight27/wind-turbine.jpg"),
];
export const insight28Media = [
  require("./media/forInsights/insight28/offshore-wind-farm.jpeg"),
];
export const insight29Media = [
  require("./media/forInsights/insight29/wind-turbine.jpeg"),
];
export const insight30Media = [
  require("./media/forInsights/insight30/offshore-wind.jpeg"),
];
export const insight31Media = [
  require("./media/forInsights/insight31/offshore-wind.jpeg"),
];
export const insight32Media = [
  require("./media/forInsights/insight32/wind-turbine.jpeg"),
];
export const insight33Media = [
  require("./media/forInsights/insight33/offshore-wind-farm.jpeg"),
];
export const insight34Media = [
  require("./media/forInsights/insight34/wind-turbine-shipment.jpg"),
];
export const insight35Media = [
  require("./media/forInsights/insight35/wind-turbine.jpeg"),
];
export const insight36Media = [
  require("./media/forInsights/insight36/wind-turbine.jpeg"),
];
export const insight37Media = [
  require("./media/forInsights/insight37/wind-farm-construction.jpeg"),
];
export const insight38Media = [
  require("./media/forInsights/insight38/wind-farm-construction.jpg"),
];
export const insight39Media = [
  require("./media/forInsights/insight39/wind-farm-shipping.jpg"),
];
export const insight40Media = [
  require("./media/forInsights/insight40/wind-turbine_on_ladder.jpg"),
];
export const insight41Media = [
  require("./media/forInsights/insight41/offshore-wind-construction-site.jpg"),
];
export const insight42Media = [
  require("./media/forInsights/insight42/offshore-wind-shipping.jpeg"),
];
export const insight43Media = [
  require("./media/forInsights/insight43/offshore-wind-farm.jpg"),
];
export const insight44Media = [
  require("./media/forInsights/insight44/offshore-wind-pole.jpg"),
];
